export const pluralise = (singular: string, plural: string, count: number) => (count > 1 ? plural : singular);

export const formatCatNames = (names: string[]) => {
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};

export const formatPossessiveCatNames = (names: string[]) =>
  formatCatNames(names.map((name) => `${name}'s`));
